import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import WhatIsFND from "@/pages/WhatIsFND";
import Symptoms from "@/pages/Symptoms";
import PersonalStory from "@/pages/PersonalStory";
import Resources from "@/pages/Resources";
import ForKids from "@/pages/ForKids";
import ForKidsPrint from "@/pages/ForKidsPrint";
import Treatments from "@/pages/Treatments";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import Community from "@/pages/Community";
import CommunityChannel from "@/pages/CommunityChannel";
import Admin from "@/pages/Admin";
import Support from "@/pages/Support";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/what-is-fnd" element={<WhatIsFND />} />
              <Route path="/symptoms" element={<Symptoms />} />
              <Route path="/treatments" element={<Treatments />} />
              <Route path="/for-kids" element={<ForKids />} />
              <Route path="/for-kids/print" element={<ForKidsPrint />} />
              <Route path="/my-story" element={<PersonalStory />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/support" element={<Support />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/community"
                element={
                  <ProtectedRoute>
                    <Community />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/community/:slug"
                element={
                  <ProtectedRoute>
                    <CommunityChannel />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
